<app-auth-container>
  <img class="autentique-logo smartphone" src="assets/logo-and-text-white.png" alt="" />
  <img class="autentique-logo tablet" src="assets/Autentique.svg" alt="" />
  <p class="auth__title">{{ 'auth.registerWith' | translate }}</p>

  <div class="auth__methods forceDefaultColors">
    @if (shouldShowOauth()) {
      <app-google-oauth
        class="auth__methods-option"
        context="signup"
        uxMode="popup"
        type="standard"
        shape="rectangular"
        theme="outline"
        text="signup_with"
        size="large"
        width="235"
        logoAlignment="left"
        (callback)="login(AuthenticationMethod.Google, $event)"
      >
      </app-google-oauth>

      <div class="oauthHoverColor">
        <button type="button" class="auth__methods-option face" [disabled]="isLoading" (click)="login(AuthenticationMethod.Facebook)">
          <i class="fab fa-facebook"></i>
          <span>{{ 'auth.registerWithFacebook' | translate }}</span>
        </button>
      </div>

      <div class="oauthHoverColor">
        <button type="button" class="auth__methods-option microsoft" [disabled]="isLoading" (click)="login(AuthenticationMethod.Microsoft)">
          <i class="fab fa-microsoft"></i>
          <span>{{ 'auth.registerWithMicrosoft' | translate }}</span>
        </button>
      </div>
    }

    @if (route.snapshot.queryParams.sms) {
      <button type="button" class="auth__methods-option wtap" [disabled]="isLoading" (click)="login(AuthenticationMethod.Sms)">
        <figure class="icon hide" style="background-image: url('/assets/smartphone.svg')"></figure>
        <span>{{ 'auth.registerWithPhone' | translate }}</span>
      </button>
    }
  </div>

  @if (shouldShowOauth() || route.snapshot.queryParams.sms) {
    <div class="d-flex justify-content-center align-items-center hr">
      <hr class="m-0" />
      <p class="auth__alternative m-0">{{ 'auth.or' | translate }}</p>
    </div>
  }

  <form class="field__form" (ngSubmit)="sendEmailVerificationPrompt()" [formGroup]="form" novalidate>
    <label class="field__holder" [appFormControlWrap]="form.get('email')">
      <input type="email" class="field" formControlName="email" name="email" autocomplete="email" required appValidEmail />
      <span class="field__placeholder">{{ 'profile.emailAdress' | translate }}</span>
    </label>

    <label class="field__holder password" [appFormControlWrap]="form.get('password')">
      <input type="password" class="field" formControlName="password" name="password" autocomplete="new-password" required minlength="8" appShowPassword data-sentry-mask />
      <span class="field__placeholder">{{ 'profile.definePassword' | translate }}</span>
    </label>

    <div class="submit-holder">
      <button type="submit" class="submit btn-L btn-filled" [disabled]="isLoading || form.invalid">{{ 'button.forward' | translate }}</button>
      <button type="button" routerLink="/entrar" class="back btn-L btn-text">{{ 'button.back' | translate }}</button>
    </div>

    <a routerLink="/entrar" class="auth__link mx-auto">{{ 'profile.alreadyHasAcc' | translate }}</a>
  </form>
</app-auth-container>
